import React from 'react';
import { useNavigate } from 'react-router-dom';
import './UnderConstruction.css';

function UnderConstruction({ pageName }) {
  const navigate = useNavigate();

  return (
    <div className="under-construction">
      <div className="construction-content">
        <h1>🚧 Under Construction 🚧</h1>
        <h2>{pageName.charAt(0).toUpperCase() + pageName.slice(1)} Page</h2>
        <p>We're working hard to bring you this feature soon!</p>
        <button onClick={() => navigate('/dashboard')}>
          Return to Dashboard
        </button>
      </div>
    </div>
  );
}

export default UnderConstruction; 